import { observer } from 'mobx-react';
import PreviewStore from '../../Store';
import LearningDesign from '../LearningDesign';
import ProductCollection from '../ProductCollections/ProductCollection';
import { Section } from '../../../../../Types';
import { DraggableProvided } from '@hello-pangea/dnd';

interface Props {
  section: Section;
  store: PreviewStore;
  provided: DraggableProvided;
}

function SectionContent({ section, store, provided }: Props) {
  switch (section.kind) {
    case 'learning-design-section':
      return (
        <LearningDesign
          key={section.resource.payload.id}
          store={store.learningCollectionStore}
          section={section}
          provided={provided}
        />
      );
    case 'product-collection-section':
      return (
        <ProductCollection
          name={section.resource.payload.name}
          experienceCount={section.resource.payload.experiences.length}
          key={section.resource.payload.id}
          provided={provided}
        />
      );
  }
}

export default observer(SectionContent);
